export default function (Alpine) {
    Alpine.store('oneClickBuy', {
        open: false,
        loading: false,
        errors: null,

        product: {
            product_id: 0,
            product_name: '',
            article: '',
            product_url: '',
            unit_price: 0,
            quantity: 1,
            total_price: 0,
        },

        show(product) {
            this.product = Object.assign({}, this.product, product);
            this.errors = null;
            this.open = true;
        },

        close() {
            this.open = false;
        },

        async submit(e) {
            if (this.loading) return;

            this.loading = true;
            this.errors = null;

            const form = e.target;
            const formData = new FormData(form);

            const payload = {};
            for (const [key, value] of formData.entries()) {
                payload[key] = value;
            }

            Object.assign(payload, this.product);

            try {
                const res = await fetch(
                    Alpine.store('app').routes.forms.submit,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'X-CSRF-TOKEN': Alpine.store('app').csrf,
                        },
                        body: JSON.stringify({
                            type: 'Купить в 1 клик',
                            payload,
                        }),
                    }
                );

                const data = await res.json();
                if (!res.ok) throw data;

                form.reset();
                this.close();
                Alpine.store('formSuccess').show();

            } catch (err) {
                this.errors = err?.message ?? 'Ошибка отправки';
            } finally {
                this.loading = false;
            }
        },
    });
}
